import DownloadApp from "../components/DownloadApp";
import PricingSection from "../components/PageSections/Pricing/PricingSection";


const PricingPage = () => {
    return (
        <main>
            <PricingSection />          
        </main>
    );
};

export default PricingPage;
